import OrderLifetimeSettingsPanel from './OrderLifetimeSettings';
import './styles.css';

const OrderLifetimeManagement: React.FC = () => (
    <div className="settings-management container-fluid">
        <OrderLifetimeSettingsPanel />
    </div>
);

export default OrderLifetimeManagement;